import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Entry } from 'contentful';
import { NewsContentPage } from 'src/app/model/page/news-content-page';
import { ContentfulService } from 'src/app/service/contentful.service';
import { ModelValidator } from 'src/app/validator/model-validator';
import htmlTitle from 'src/assets/json/redirects/html-title.json';

@Component({
  selector: 'app-news-content-page',
  templateUrl: './news-content-page.component.html',
  styleUrls: ['./news-content-page.component.scss']
})
export class NewsContentPageComponent implements OnInit {
  pageTitle = '';
  year = '';

  newsContentPage: NewsContentPage = {} as NewsContentPage;

  constructor(private activatedRoute: ActivatedRoute, private contentfulService: ContentfulService) {}

  ngOnInit(): void {
    htmlTitle.filter((title) => {
      if (title.page === 'news') {
        this.newsContentPage.htmlTitle = title.htmlTitle;
      }
    });
    this.activatedRoute.params.subscribe((params) => {
      this.pageTitle = params['pageTitle'];
      this.year = params['year'];

      // console.log('pageTitle : ' + this.year + '-' + this.pageTitle);

      const query = { 'fields.title': this.year + '-' + this.pageTitle };
      this.contentfulService.getPageContentResponse(query).then((newsContentPageEntries) => {
        this.newsContentPage.introductionSections = [];
        this.newsContentPage.belowNoteSections = [];
        this.newsContentPage.imageSections = [];
        this.newsContentPage.accordionSections = [];
        this.newsContentPage.noteSections = [];
        this.newsContentPage.tableSections = [];

        this.mapHtmlTitle(newsContentPageEntries.items);
        this.mapBanner(newsContentPageEntries.includes.Entry);
        this.mapPageInfo(newsContentPageEntries.items);
        this.mapNoteSection(newsContentPageEntries.includes.Entry);
        this.mapEntryToSection(newsContentPageEntries.includes.Entry);
        this.mapTableSection(newsContentPageEntries.includes.Entry);
        this.mapImage(newsContentPageEntries.includes.Asset);
      });
    });
  }

  private mapHtmlTitle(items: Entry<any>[]) {
    items.forEach((entry: any) => {
      this.newsContentPage.htmlTitle = entry.fields.htmlTitle;
    });
  }

  private mapBanner(newsContentPageEntries: Entry<any>[]) {
    newsContentPageEntries
      .filter((entry) => ModelValidator.isBanner(entry))
      .forEach((entry) => {
        this.mapEntryToBanner(entry);
      });
  }

  private mapEntryToBanner(entry: Entry<any>) {
    let imageDetails: any = entry.fields['image'];
    this.newsContentPage.banner = {
      title: entry.fields['title'] as string,
      subTitle: entry.fields['subTitle'] as string,
      image: imageDetails.fields.file.url
    };
  }

  private mapPageInfo(items: Entry<any>[]) {
    this.newsContentPage.banner.lastUpdated = items.pop()?.fields?.['lastUpdated'] as string;
  }

  private mapImage(assets: Entry<any>[]) {
    assets.forEach((asset) => {
      let givenTitle: any = asset.fields['title'] as string;
      assets.filter((imageURL) => {
        let imageFile: any = imageURL.fields?.['file'];
        if (givenTitle.split('#').pop() === 'imageSection') {
          this.newsContentPage.image = imageFile.url;
        }
      });
    });
  }

  private mapNoteSection(newsContentPageEntries: Entry<any>[]) {
    newsContentPageEntries
      .filter((entry) => ModelValidator.isNote(entry))
      .forEach((entry) => {
        if (entry.fields['group'] === 'note') {
          this.mapEntryToNoteSection(entry);
        }
      });
  }

  private mapEntryToNoteSection(entry: Entry<any>) {
    let givenTitle: any = entry.fields['title'] as string;
    let pageTitle = givenTitle.split('#').pop();
    this.newsContentPage.noteSections.push({
      title: pageTitle,
      body: entry.fields['body'] as string,
      group: entry.fields['group'] as string,
      category: entry.fields['category'] as string,
      order: entry.fields['order'] as number,
      fullTitle: entry.fields['fullTitle'] as string,
      iconClass: entry.fields['iconClass'] as string,
      noteClass: entry.fields['noteClass'] as string
    });
    this.newsContentPage.noteSections.sort((a, b) => a.order - b.order);
  }

  private mapEntryToSection(newsContentPageEntries: Entry<any>[]) {
    newsContentPageEntries
      .filter((entry) => ModelValidator.isSection(entry))
      .forEach((entry) => {
        switch (entry.fields['group']) {
          case 'introduction':
            this.mapEntryToIntroductionSection(entry);
            break;
          case 'section-below-table':
            this.mapEntryTobelowNoteSections(entry);
            break;
          case 'imageSection':
            this.mapEntryToImageSections(entry);
            break;
          case 'accordion':
            this.mapEntryToAccordionSection(entry);
            break;
          default:
            console.error('New group Found - ' + entry.fields['title']);
            break;
        }
      });
  }

  private mapEntryToIntroductionSection(entry: Entry<any>) {
    let givenTitle: any = entry.fields['title'] as string;
    let pageTitle = givenTitle.split('#').pop();

    this.newsContentPage.introductionSections.push({
      title: pageTitle,
      body: entry.fields['body'] as string,
      group: entry.fields['group'] as string,
      order: entry.fields['order'] as number,
      category: entry.fields['category'] as string,
      heading: entry.fields['heading'] as string,
      subBody: entry.fields['subBody'] as string,
      noteSections: this.newsContentPage.noteSections.filter((noteSection) => noteSection.category === entry.fields['title'])
    });
    this.newsContentPage.introductionSections.sort((a, b) => a.order - b.order);
  }

  private mapEntryToImageSections(entry: Entry<any>) {
    let givenTitle: any = entry.fields['title'] as string;
    let pageTitle = givenTitle.split('#').pop();

    this.newsContentPage.imageSections.push({
      title: pageTitle,
      body: entry.fields['body'] as string,
      group: entry.fields['group'] as string,
      order: entry.fields['order'] as number,
      category: entry.fields['category'] as string,
      heading: entry.fields['heading'] as string,
      subBody: entry.fields['subBody'] as string
    });
    this.newsContentPage.imageSections.sort((a, b) => a.order - b.order);
  }

  private mapEntryTobelowNoteSections(entry: Entry<any>) {
    let givenTitle: any = entry.fields['title'] as string;
    let pageTitle = givenTitle.split('#').pop();

    this.newsContentPage.belowNoteSections.push({
      title: pageTitle,
      body: entry.fields['body'] as string,
      group: entry.fields['group'] as string,
      order: entry.fields['order'] as number,
      category: entry.fields['category'] as string,
      heading: entry.fields['heading'] as string,
      subBody: entry.fields['subBody'] as string,
      noteSections: this.newsContentPage.noteSections.filter((noteSection) => noteSection.category === entry.fields['title'])
    });
    this.newsContentPage.belowNoteSections.sort((a, b) => a.order - b.order);
  }

  private mapEntryToAccordionSection(entry: Entry<any>) {
    let givenTitle: any = entry.fields['title'] as string;
    let pageTitle = givenTitle.split('#').pop();

    this.newsContentPage.accordionSections.push({
      title: pageTitle,
      body: entry.fields['body'] as string,
      group: entry.fields['group'] as string,
      order: entry.fields['order'] as number,
      category: entry.fields['category'] as string,
      heading: entry.fields['heading'] as string,
      subBody: entry.fields['subBody'] as string
    });
    this.newsContentPage.accordionSections.sort((a, b) => a.order - b.order);
  }

  private mapTableSection(newsContentPageEntries: Entry<any>[]) {
    newsContentPageEntries
      .filter((entry) => ModelValidator.isTableSection(entry))
      .forEach((entry) => {
        this.mapEntryToTableSection(entry);
      });
  }
  private mapEntryToTableSection(entry: Entry<any>) {
    let givenTitle: any = entry.fields['title'] as string;
    let pageTitle = givenTitle.split('#').pop();

    this.newsContentPage.tableSections.push({
      title: pageTitle,
      body: entry.fields['body'] as string,
      group: entry.fields['group'] as string,
      order: entry.fields['order'] as number,
      table: entry.fields['table'] as string,
      heading: entry.fields['heading'] as string,
      noteSections: this.newsContentPage.noteSections.filter((noteSection) => noteSection.category === entry.fields['title'])
    });
    this.newsContentPage.tableSections.sort((a, b) => a.order - b.order);
  }
}
